module.exports = __webpack_public_path__ + "img/category-new-released.1c35206b.png";